












































import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import RecurrenceUtils from "../../utils/recurrenceUtils";
import { RecurrenceRule } from "@/shared/Recurrence";
import RapportSelection from "@/components/rapportSelection.vue";
import ErrorMixin from "@/mixins/errorMixins";
import { Rapport } from "@/shared/Rapport";
import RuleAdder from "./ruleAdder.vue";

@Component({
  components: {
    RapportSelection,
    RuleAdder,
  },
})
export default class RegleRecurrence extends mixins(ErrorMixin) {
  @Prop() public listRules!: RecurrenceRule[];
  @Prop({ required: true, type: Function })
  public ruleAdderComponent!: typeof Vue;
  @Prop() public restaurantId!: number;
  public configRules: { [key: string]: any } = {};
  public adding = false;
  public selectedRule: RecurrenceRule = new RecurrenceRule();

  public loading = false;

  public mounted() {
    this.loading = true;
    RecurrenceUtils.getConfigRules().then((response: any) => {
      this.configRules = response;
      delete this.configRules.FabricExportableComposite;
      delete this.configRules.FabricExportableGroovy;
      delete this.configRules.FabricExportableBI;
      // TODO : à retirer ?
      delete this.configRules.FabricExportableVidage;
      this.loading = false;
    });
  }

  public selectRule(rule: RecurrenceRule) {
    rule.$decodedScript = JSON.parse(rule.script);
    this.selectedRule = rule;
  }

  /**
   * Méthode permettant d'ajouter une nouvelle règle
   */
  public async addRule() {
    await RecurrenceUtils.addRule(this.selectedRule).then(
      (response: any) => {
        this.listRules.push(response);
        this.selectedRule = response;
        this.setSuccess(this.$t("ruleAdded").toString());
      },
      (error: any) => {
        this.setError(error);
      }
    );
  }

  public getDisplayedRuleName(rule: any): string {
    return rule.name;
  }

  public prepareAddRule() {
    this.selectedRule = new RecurrenceRule();
    this.adding = true;

  }

  public isSelected(rule: any) {
    return this.selectedRule.id === rule.id;
  }

  /**
   * Méthode permettant de supprimer une règle
   * @param rule : RecurrenceRule
   */
  public async deleteRule(rule: RecurrenceRule) {
    RecurrenceUtils.deleteRule(this.selectedRule.id).then(
      (response: any) => {
        this.$emit("deleteRule", rule);
        this.setSuccess(this.$t("deletedRule").toString());
        this.selectedRule = new RecurrenceRule();
      },
      (error: any) => this.setError(error)
    );
  }

  /**
   * Méthode permettant de modifier une règle
   */
  public async updateRule(ruleToUpdate: RecurrenceRule) {
    await RecurrenceUtils.updateRule(ruleToUpdate).then(
        (response: any) => {
            const index = this.listRules.findIndex((r) => r.id === ruleToUpdate.id);
            if (index !== -1) {
                this.$set(this.listRules, index, response);
                // Mettre à jour la règle sélectionnée aussi
                this.selectedRule = response;
            }
            this.setSuccess(this.$t("ruleUpdated").toString());
        }
    );
}

  get sites(): any {
    const sites = this.$store.getters["login/sites"];
    const result: string[] = [];

    sites.forEach((element: any) => {
      result.push(element.libelle);
    });

    return result;
  }
}
